/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clubs_Field_ScopeInputs */

const en_us2_clubs_field_scope = /** @type {(inputs: Clubs_Field_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Who sees the ranking`)
};

const pt_br2_clubs_field_scope = /** @type {(inputs: Clubs_Field_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quem vê o ranking`)
};

const es_419_clubs_field_scope = /** @type {(inputs: Clubs_Field_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quién ve el ranking`)
};

const pt_pt2_clubs_field_scope = /** @type {(inputs: Clubs_Field_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quem vê a classificação`)
};

const fr_fr2_clubs_field_scope = /** @type {(inputs: Clubs_Field_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Qui voit le classement`)
};

const de_de2_clubs_field_scope = /** @type {(inputs: Clubs_Field_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wer die Rangliste sieht`)
};

const it_it2_clubs_field_scope = /** @type {(inputs: Clubs_Field_ScopeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chi vede la classifica`)
};

/**
* | output |
* | --- |
* | "Who sees the ranking" |
*
* @param {Clubs_Field_ScopeInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const clubs_field_scope = /** @type {((inputs?: Clubs_Field_ScopeInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clubs_Field_ScopeInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_clubs_field_scope(inputs)
	if (locale === "es-419") return es_419_clubs_field_scope(inputs)
	if (locale === "pt-PT") return pt_pt2_clubs_field_scope(inputs)
	if (locale === "fr-FR") return fr_fr2_clubs_field_scope(inputs)
	if (locale === "de-DE") return de_de2_clubs_field_scope(inputs)
	if (locale === "it-IT") return it_it2_clubs_field_scope(inputs)
	return en_us2_clubs_field_scope(inputs)
});
export { clubs_field_scope as "clubs.field_scope" }